<sigv-query-form-container
  [autoCollapse]="false"
  [(collapse)]="collapse"
  (search)="pageActions.onFormSearch()"
  (cancel)="pageActions.onFormClear()"
>
  <ng-template pTemplate="conditions">
    <div class="p-grid">
      <div class="p-col-4">
        <div class="p-field p-fluid">
          <div class="p-field-label">
            {{ 'Library.BankInfo.BankCode' | translate }}
          </div>
          <sigv-input-text
            [fieldName]="'bankCode'"
            [bindingFormControl]="formData.searchForm.controls.bankCode"
            [isReadOnly]="false"
          >
          </sigv-input-text>
        </div>
      </div>

      <div class="p-col-4">
        <div class="p-field p-fluid">
          <div class="p-field-label">
            {{ 'Library.BankInfo.BankName' | translate }}
          </div>
          <sigv-input-text
            [fieldName]="'bankName'"
            [bindingFormControl]="formData.searchForm.controls.bankName"
            [isReadOnly]="false"
          >
          </sigv-input-text>
        </div>
      </div>

      <div class="p-col-4">
        <div class="p-field p-fluid">
          <div class="p-field-label">
            {{ 'Library.BankInfo.BankShortName' | translate }}
          </div>
          <sigv-input-text
            [fieldName]="'bankShortName'"
            [bindingFormControl]="formData.searchForm.controls.bankShortName"
            [isReadOnly]="false"
          >
          </sigv-input-text>
        </div>
      </div>
    </div>
  </ng-template>
</sigv-query-form-container>

<sigv-input-data-table
  [value]="formData.bankList.controls"
  [columns]="pageData.displayColumns"
  [dataKey]="'value.commDisbmFormId'"
  [(first)]="pageData.first"
  [scrollable]="true"
  [scrollHeight]="'500px'"
  [paginator]="false"
  [lazy]="true"
  [reorderableColumns]="false"
  [showInformation]="false"
  (tablePaging)="pageActions.onTablePaging($event)"
  preferenceKey="Retail_Commencement_TodoList_Table"
>
  <ng-template
    pTemplate="body"
    let-rowData
    let-rowIndex="rowIndex"
    let-editing="editing"
    let-columns="columns"
  >
    <ng-container *ngIf="true; else tableRow">
      <tr>
        <ng-container *ngTemplateOutlet="tableRow"></ng-container>
      </tr>
    </ng-container>

    <ng-template #tableRow>
      <ng-container *ngFor="let col of columns">
        <td [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'bankCode'">
            <span
              style="
                color: #0000ff;
                text-decoration: underline;
                cursor: pointer;
              "
              (click)="pageActions.selectBank(rowData)"
            >
              {{
                rowData.controls.bankCode?.getRawValue() ?? ''
                  | replaceNullWith : '-'
              }}
            </span>
          </ng-container>

          <ng-container *ngSwitchCase="'bankName'">
            <ng-container>
              {{
                rowData.controls.bankName?.getRawValue() ?? ''
                  | replaceNullWith : '-'
              }}
            </ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'bankShortName'">
            <ng-container>
              {{
                rowData.controls.bankShortName?.getRawValue() ?? ''
                  | replaceNullWith : '-'
              }}
            </ng-container>
          </ng-container>
        </td>
      </ng-container>
    </ng-template>
  </ng-template>
</sigv-input-data-table>
